<template>
<div class="pb100 ">

  <v-dialog v-model="claim_dialog" max-width="400" persistent>
    <v-card>
      <v-card-title class="secondary white--text">
        <h5>Claim Edit</h5>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="claim_dialog=false">
          <v-icon>fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-4">
        {{$store.state.app.edit_claim_description}}
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="grey lighten-3">
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="submitClaim" :loading="loading">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>


  <v-card-title class="secondary white--text">
    <v-col cols="2">
      <v-icon dark>fa-id-badge</v-icon>
    </v-col>
    <v-col cols="8" class="text-center">
      <h3>My Profile</h3>
    </v-col>
    <v-col cols="2" class="text-right">
      <v-btn icon dark @click="$eventBus.$emit('play_video',$store.state.app.tutorials.profile_edit['My Profile'])">
        <v-icon>fa-question</v-icon>
      </v-btn>
    </v-col>
  </v-card-title>


  <v-card-title class="secondary lighten-1 white--text ">
    <v-col cols="6">
      <v-btn dark rounded :small="$store.state.app.display ==='xs' || $store.state.app.display ==='sm'" color="green" class="mr-2" @click="showPassword">
        <span v-if="$store.state.account.account.profile_password">Access code</span>
        <span v-else>Access code</span>
        <v-icon class="ml-2" :small="$store.state.app.display ==='xs' || $store.state.app.display ==='sm'" v-if="$store.state.account.account.profile_password">fa-lock</v-icon>
        <v-icon class="ml-2" :small="$store.state.app.display ==='xs' || $store.state.app.display ==='sm'" v-else>fa-lock-open</v-icon>
      </v-btn>
      <v-dialog v-model="show_password" persistent :width="500">
        <v-card>
          <v-card-title class="secondary white--text">
            <h5>Set Access Code</h5>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pt-4">
            <v-text-field outlined hide-details type="password" prepend-inner-icon="fa-lock" label="New Code" v-model="new_password" clearable></v-text-field>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="grey lighten-3">
            <v-btn color="error" text @click="clearPassword" :loading="loading" v-if="$store.state.account.account.profile_password">
              Remove Access Code
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="" text @click="show_password=false">
              Cancel
            </v-btn>
            <v-btn dark color="green" @click="updatePassword" :loading="loading" v-if="new_password.length>3">
              Ok
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
    <v-col cols="6" class="text-right">

      <v-btn dark rounded :small="$store.state.app.display ==='xs' || $store.state.app.display ==='sm'" color="primary" :to="$store.getters['profile/share_url']"> Share
        <v-icon :small="$store.state.app.display ==='xs' || $store.state.app.display ==='sm'" class="ml-2">fa-share</v-icon>
      </v-btn>
    </v-col>
  </v-card-title>


  <v-container>
    <v-row class="text-center text-md-left" justify="center">
      <v-col cols="12" sm="6" md="4" lg="4" xl="3" id="section-1">
        <profile-video :section="1" :tutorial="$store.state.app.tutorials.profile_edit['My Interests']"></profile-video>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="4" xl="3" id="section-2">
        <profile-video :section="2" :tutorial="$store.state.app.tutorials.profile_edit['My Work Experience']"></profile-video>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="4" xl="3" id="section-3">
        <profile-video :section="3" :tutorial="$store.state.app.tutorials.profile_edit['My Thank You Video']"></profile-video>
      </v-col>
    </v-row>


    <v-row align="center" justify="center" v-if="$store.getters['user_projects/published'].length">
      <v-col cols="12" xl="9">
        <v-card>
          <v-card-actions class="secondary white--text">
            <v-col cols="9">
              <h3>My Published Work</h3>
            </v-col>
            <v-col cols="3" class="text-right">
              <v-btn icon dark @click="$eventBus.$emit('play_video',$store.state.app.tutorials.profile_edit['My Published Work'])">
                <v-icon>fa-question</v-icon>
              </v-btn>
            </v-col>
          </v-card-actions>
          <v-container>
            <v-row align="center" justify="start">
              <v-col cols="12" sm="6" md="4" lg="4" xl="4" v-for="(project,i) in $store.getters['user_projects/published']" :key="i">
                <project-tile :project="project"></project-tile>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>


    <v-row align="center" justify="center" class="mt-4 mb-4">
      <v-col cols="12" md="12" lg="7" xl="5">
        <v-card>
          <v-card-actions class="secondary white--text">

            <v-col cols="6">
              <h3>My Links</h3>
            </v-col>

            <v-col cols="6" class="text-right">
              <input type="file" style="display:none" id="upload-resume" @change="uploadResume($event)" accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,
            text/plain, application/pdf" />
              <div class="" v-if="uploading_resume">
                <v-progress-linear color="primary" striped indeterminate height="30" dark>
                  <template>
                          <strong>Uploading Resume</strong>
                        </template>
                </v-progress-linear>
              </div>
              <div class="" v-else>
                <v-chip dark v-if="$store.state.account.account.resume" class="ma-2" close @click:close="deleteResume" color="blue">
                  <a target="_blank" class="nolink white--text" :href="$store.state.account.account.resume">My Resume</a>
                </v-chip>
                <v-chip v-else class="ma-2" color="blue" @click:close="selectFile" close outlined dark close-icon="fa fa-plus">
                  My Resume
                </v-chip>
              </div>

            </v-col>

          </v-card-actions>
          <v-list class="py-0">
            <v-list-item class="secondary lighten-1">
              <v-list-item-content>
                <v-text-field dark hide-details clearable outlined label="Add Link" v-model="new_link" @keyup.enter="addLink"></v-text-field>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn fab dark color="primary" small @click="addLink" :disabled="!validLink">
                  <v-icon small>fa-plus</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>

            <v-list-item class="py-0" v-if="$store.getters['profile/links'].length">
              <v-list-item-icon>

              </v-list-item-icon>
              <v-list-item-content>

              </v-list-item-content>

              <v-list-item-action>

              </v-list-item-action>

              <v-list-item-action>
                <div>
                  <span class="font-weight-bold grey--text text--darken-2">Visible</span>
                </div>
              </v-list-item-action>

            </v-list-item>
            <v-divider v-if="$store.getters['profile/links'].length"></v-divider>
            <template v-for="(link,i) in $store.getters['profile/links']">
              <v-list-item class="" :key="i">
                <v-list-item-icon>
                  <v-icon :color="$helpers.linkColor(link.url)" large>{{$helpers.linkIcon(link.url)}}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <a class="nolink caption" :href="link.url" target="_blank"><span class="">{{link.url}}</span></a>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon small @click="removeLink(link)">
                    <v-icon small>fa-times</v-icon>
                  </v-btn>
                </v-list-item-action>
                <v-list-item-action>
                  <div>
                    <v-switch color="green" :false-value="0" :true-value="1" hide-details class="mt-0" inset dense :input-value="link.visible" @change="updateLink(link,$event)"></v-switch>
                  </div>
                </v-list-item-action>
              </v-list-item>
              <v-divider :key="'d' + i" v-if="i < $store.getters['profile/links'].length-1"></v-divider>
            </template>
          </v-list>
        </v-card>
      </v-col>
    </v-row>



    <v-row align="center" justify="center">
      <v-col cols="12" md="12" lg="7" xl="5">
        <v-card>
          <v-card-actions class="secondary">

            <v-col cols="9">
              <h3 class="white--text">Support</h3>
            </v-col>
            <v-col cols="3" class="text-right">
              <v-btn icon dark @click="$eventBus.$emit('play_video',$store.state.app.tutorials.profile_edit['Support'])">
                <v-icon>fa-question</v-icon>
              </v-btn>
            </v-col>



          </v-card-actions>
          <v-divider></v-divider>
          <v-card-actions>
            <v-chip class="ma-2 clicky" color="green" text-color="white" v-for="(sponsor,i) in  $store.getters['app/supportOptions']" :key="i">
              <v-avatar left class="white">
                <v-icon small color="green">fa-dollar-sign</v-icon>
              </v-avatar>
              {{sponsor}}
            </v-chip>
          </v-card-actions>
          <v-card-text class="pt-0">
            {{$store.state.app.support_description}}
          </v-card-text>
          <v-card-actions class="grey lighten-3">
            <v-spacer></v-spacer>
            <span class="pull-left mr-2 pt-1 font-weight-bold grey--text text--darken-2">Visible</span>
            <div>
              <v-switch color="green" hide-details class="mt-0" inset dense :false-value="0" :true-value="1" :input-value="$store.state.account.account.support_visible" @change="$store.dispatch('account/update',{support_visible:$event})"></v-switch>
            </div>
          </v-card-actions>

        </v-card>
      </v-col>
    </v-row>



  </v-container>

</div>
</template>
<script>
import profileVideo from "@/components/profile_edit/profile-video-tile"
import projectTile from "@/components/profile_edit/project-tile"


export default {
  name: "",
  components: {
    profileVideo: profileVideo,
    projectTile: projectTile
  },
  computed: {
    validLink() {
      let isOnlist = false;
      this.$store.state.app.links_whitelist.forEach(function(link) {
        if (this.new_link.toLowerCase().includes(link.toLowerCase())) {
          isOnlist = true;
        }
      }.bind(this))
      return isOnlist
    }
  },
  created() {
    this.load()
  },
  data: () => ({
    uploading_resume: false,
    show_contest_dialog: false,
    show_links: false,
    new_link: '',
    claim_dialog: false,
    loading: false,
    show_password: false,
    new_password: '',
  }),
  methods: {
    async load() {
      await Promise.all([this.$store.dispatch('profile_edit/load'),
        this.$store.dispatch('profile/load'),
        this.$store.dispatch('user_projects/load')
      ])
      if (this.$route.hash) {
        this.scrollToSection(this.$route.hash)
      }
    },
    showPassword() {
      this.new_password = ''
      this.show_password = true;
    },
    async updatePassword() {
      this.loading = true;
      await this.$store.dispatch('account/updateProfilePassword', {
        password: this.new_password
      })
      this.loading = false;
      this.show_password = false;
    },
    async clearPassword() {
      this.loading = true;
      await this.$store.dispatch('account/clearProfilePassword', null)
      this.loading = false;
      this.show_password = false;
    },
    deleteResume() {
      if (!confirm("Delete resume ?")) {
        return;
      }
      this.$store.dispatch('account/deleteResume')
    },
    async uploadResume(ev) {
      ev.preventDefault();
      let file;
      if (ev.target.files) {
        file = ev.target.files[0]
      }
      if (file) {
        this.uploading_resume = true;
        await this.$store.dispatch('account/uploadResume', file);
        this.uploading_resume = false
      }

    },
    selectFile() {
      document.querySelector("#upload-resume").click();
    },
    updateLink(link, v) {
      this.$store.dispatch('profile/updateLink', {
        link: link,
        update: {
          visible: v
        }
      })
    },
    claimEdit() {
      this.claim_dialog = true
    },
    submitClaim() {
      this.loading = true;
      this.$store.dispatch('profile_edit/claim_edit')
      this.claim_dialog = false
      this.loading = false;
    },
    removeLink(link) {
      if (!confirm("Confirm delete ?")) {
        return
      }
      this.$store.dispatch('profile/deleteLink', link)
    },
    updateProject(project) {
      this.$store.commit('profile_edit/project_updated', project)
    },
    checkLink(link) {

      let isOnlist = false;
      this.$store.state.app.links_whitelist.forEach(function(l) {
        if (link.toLowerCase().includes(l.toLowerCase())) {
          isOnlist = true;
        }
      }.bind(this))
      return isOnlist;
    },
    addLink() {

      let valid = this.checkLink(this.new_link)
      if (!valid) {
        return alert("Invalid link")
      }
      if (!this.new_link.startsWith("http")) {
        this.new_link = `https://${this.new_link}`
      }
      this.$store.dispatch('profile/createLink', this.new_link)
      this.new_link = ''
    },
    scrollToSection(section) {
      setTimeout(function() {
        this.$vuetify.goTo(section, {
          duration: 300,
          offset: 70,
          easing: "easeInOutCubic",
        })
      }.bind(this), 100)
    },
  }
}
</script>
<style lang="scss" scoped>
</style>
